import { atom } from 'recoil'
import { ICartDictionary, IConfig, ISearchStats, IOrder } from '@engyalo/storefront-types/lib/plugins/model'
import { getStoreFront_orderConfig as IOrderConfig } from '@engyalo/storefront-types/lib/graphql/storefront'

export const searchStats = atom({
  key: 'searchStats',
  default: {
    openCount: 0,
    searchCount: 0,
  } as ISearchStats,
})

export const cartState = atom({
  key: 'cartState',
  default: {} as ICartDictionary,
})

export const orderState = atom({
  key: 'cartSettingsState',
  default: {
    orderNote: '',
  } as IOrder,
})

export const configState = atom({
  key: 'configState',
  default: {
    logo: 'https://storage.googleapis.com/yalo-img/4k/logo-purple.png',
    favicon: 'https://storage.googleapis.com/yalo-img/yaloicon.ico',
    currency: '$',
    currencyPrefix: 'MXN',
    enabledOrderNote: false,
    enabledCustomCart: false,
    enabledProductDetail: true,
    customer: '',
  } as IConfig,
})

export const orderConfigState = atom({
  key: 'orderConfigState',
  default: {} as IOrderConfig,
})
